import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import { Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Button, CardMedia, Grid } from '@mui/material';
import Save from '@mui/icons-material/Save';
import Close from '@mui/icons-material/Close';
import PhotoCamera from '@mui/icons-material/PhotoCamera';
import CloudUpload from '@mui/icons-material/CloudUpload'
import { useStateValue } from '../../Contexto/store';

import { RutinaLeerArchivoInputFile } from '../../Utilidades/ManejoArchivos';
import { mostrarDialogoWebCam, DialogoWebCam } from './WebCamera'

import { styleToolBar, styleCameraButtons, styleTable } from '../Tool/Style';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: '10px 12px',
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

const Input = styled('input')({
    display: 'none',
});

const BootstrapDialogTitle = (props) => {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    style={styleToolBar.IconButton}
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8
                    }}>
                    <Close style={styleToolBar.Icon} />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
};

BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};

let funcionCargarModal;
let validaCargaModal;

export const DialogoSubirImagen = ({ imagenVer, onClickGuardar, onInputChange, tituloModal = '' }) => {

    const [{ etiquetasIdioma }, dispatch] = useStateValue();

    const [imagenActual, setImagenActual] = useState({
        ImageName: '',
        ContentType: '',
        ContentBase64: ''
    });

    // Se declara la variable de estado que representa al idioma para las etiquetas del componente
    const [etiquetas, setEtiquetas] = useState({
        EtiquetasComponente: etiquetasIdioma ? etiquetasIdioma.EtiquetasComponente : DiccionarioEtiquetas.IdiomaDefault.Etiquetas,
        CodigoIdioma: etiquetasIdioma ? etiquetasIdioma.CodigoIdioma : DiccionarioEtiquetas.CodigoIdioma
    });

    useEffect(() => {
        // se llama al dispatch para que como tal se actualice el reducer
        setEtiquetas({
            EtiquetasComponente: etiquetasIdioma ? etiquetasIdioma.EtiquetasComponente : DiccionarioEtiquetas.IdiomaDefault.Etiquetas,
            CodigoIdioma: etiquetasIdioma ? etiquetasIdioma.CodigoIdioma : DiccionarioEtiquetas.CodigoIdioma
        });
    }, [etiquetasIdioma]);

    const [cargaModalImagen, setCargaModalImagen] = useState(false);
    funcionCargarModal = setCargaModalImagen;
    validaCargaModal = cargaModalImagen;

    if (imagenVer == undefined) {
        imagenVer = {
            ImageName: "",
            ContentType: "",
            ContentBase64: ""
        };
    }

    useEffect(() => {
        setImagenActual({
            ImageName: imagenVer?.ImageName,
            ContentType: imagenVer?.ContentType,
            ContentBase64: imagenVer?.ContentBase64
        });
    }, [cargaModalImagen]);

    async function handleFileInputChange(e) {
        const base64file = await RutinaLeerArchivoInputFile(e);
        setImagenActual({
            ImageName: base64file.nombre,
            ContentType: base64file.tipo,
            ContentBase64: base64file.contenido
        });
        onInputChange(base64file.nombre, base64file.tipo, base64file.contenido);
    };

    async function captureCameraSet(url) {
        var today = new Date();
        const ImgN = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate() + today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds();
        setImagenActual({
            ImageName: ImgN,
            ContentType: "image/jpeg",
            ContentBase64: url
        });
        onInputChange(ImgN, "image/jpeg", url);
        mostrarDialogoWebCam();
    };

    async function handleSaveImage() {
        onClickGuardar();
        setCargaModalImagen(false);
    };

    const inputhandleClick = event => {
        const { target = {} } = event || {};
        target.value = "";
    };

    return (
        <div>
            <DialogoWebCam setCapture={captureCameraSet} />
            <BootstrapDialog
                onBackdropClick="false"
                onClose={mostrarDialogoSubirImagen}
                aria-labelledby="customized-dialog-title"
                open={cargaModalImagen}
            >
                <BootstrapDialogTitle id="customized-dialog-title" onClose={mostrarDialogoSubirImagen}>
                    {(tituloModal === '') ? etiquetas.EtiquetasComponente.DialogoSubirImagen.Et_TituloPrincipal : tituloModal}
                </BootstrapDialogTitle>

                <DialogContent style={{ position: 'relative' }} >

                    <CardMedia
                        component='img'
                        alt=""
                        style={{
                            width: '400px', height: '400px', border: '1px solid rgb(231, 235, 239)', margin: '10px 0 10px 0',
                            objectFit: 'fill', position: 'relative', left: '50%', transform: 'translateX(-50%)'
                        }}
                        src={imagenActual?.ContentBase64}>
                    </CardMedia>

                </DialogContent>
                <DialogActions style={{ justifyContent: 'center' }}>
                    <Grid container spacing={1} style={{ backgroundColor: 'transparent', padding: 0, margin: 0, width: 'auto' }}>
                        <Grid item xs={6} sm={6} md={6}  >
                            <label htmlFor="icon-button-file">
                                <Input accept="image/png, image/jpeg" id="icon-button-file" type="file" onChange={handleFileInputChange} onClick={inputhandleClick} />
                                <Button style={styleCameraButtons.Button} aria-label="upload picture" fullWidth component="span" size="large" >
                                    {etiquetas.EtiquetasComponente.DialogoSubirImagen.Et_BtnSubir}
                                </Button>
                            </label>
                        </Grid>
                        <Grid item xs={6} sm={6} md={6}>
                            <Button style={styleCameraButtons.Button} onClick={mostrarDialogoWebCam} fullWidth size="large" >
                                {etiquetas.EtiquetasComponente.DialogoSubirImagen.Et_BtnCamara}
                            </Button>
                        </Grid>
                        <Grid item xs={3} sm={3} md={3}>                            
                        </Grid>
                        <Grid item xs={6} sm={6} md={6}>
                            <Button style={styleCameraButtons.ButtonPrimary} onClick={handleSaveImage} fullWidth size="large" >
                                {etiquetas.EtiquetasComponente.General.Et_tbnGuardar}
                            </Button>
                        </Grid>
                    </Grid>
                </DialogActions>
            </BootstrapDialog>
        </div>
    );
}

export const mostrarDialogoSubirImagen = () => {
    funcionCargarModal(!validaCargaModal);
}